/**
 * Microsoft Brand Agent: mobile icon-only launcher (Horizon mobile breakpoint).
 * App renders in an open shadow root, so document styles cannot reach its nudges.
 * Style only the closed entrypoint; preserve native tap/keyboard/chat.
 * Recheck the app DOM contract when upgrading Microsoft Brand Agent or Horizon.
 */
(() => {
  const styleId = 'sunco-brand-agent-mobile-style';
  const styles = `/* Keep Microsoft's closed mobile launcher compact; the opened chat is untouched. */
@media (max-width: 749px) {
  [data-testid="entrypoint"] > :not([role="button"]),
  [data-testid="entrypoint"] > [role="button"] > div:not(:first-of-type),
  [data-testid="entrypoint"] > [role="button"] > div:first-of-type > :not(:first-child) {
    display: none !important;
  }
  [data-testid="entrypoint"] > [role="button"] {
    border: 0 !important;
    padding: 4px !important;
    box-shadow: none !important;
  }
  [data-testid="entrypoint"] > [role="button"] > div:first-of-type {
    padding: 0 !important;
    gap: 0 !important;
    background: transparent !important;
  }
  [data-testid="entrypoint"] > [role="button"] > div:first-of-type > :first-child {
    width: 48px !important;
    height: 48px !important;
  }
}`;
  const attachStyles = () => {
    const root = document.getElementById('ads-agent-host')?.shadowRoot;
    if (!root || root.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = styles;
    root.appendChild(style);
  };
  const start = () => {
    attachStyles();
    // Microsoft appends its host directly to body and attaches the shadow root
    // synchronously. A direct-child observer also handles host replacement.
    new MutationObserver(attachStyles).observe(document.body, { childList: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
